<div class="bisual-table">
  <form class="card paginator" [formGroup]="filterForm">
    <mat-paginator
      [length]="length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="pageIndex"
      (page)="changePage($event)"
      style="margin-right: auto"
    ></mat-paginator>
  </form>

  <div class="bisual-table-container">
    <table mat-table [dataSource]="dataSource">
      <ng-container matColumnDef="exam_name">
        <th mat-header-cell *matHeaderCellDef>Examen</th>
        <td mat-cell *matCellDef="let element">{{ element.exam_name_label }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Estado</th>
        <td mat-cell *matCellDef="let element">{{ element.status_label }}</td>
      </ng-container>

      <ng-container matColumnDef="score">
        <th mat-header-cell *matHeaderCellDef>Nota</th>
        <td mat-cell *matCellDef="let element">{{ element.score_label }}</td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th mat-header-cell *matHeaderCellDef>Fecha</th>
        <td mat-cell *matCellDef="let element">{{ element.created_at | date: 'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="actions-cell">
          <div class="table-actions">
            @if (element.can_view_detail) {
              <a
                mat-icon-button
                [routerLink]="['/employees', 'performance', 'upskilling', 'exams', element.exam_instance_id, 'evaluations', element.id]"
                matTooltip="Ver detalle"
              >
                <mat-icon>visibility</mat-icon>
              </a>
            }

            @if (element.has_imported_scanned_pdf) {
              <button mat-stroked-button type="button" (click)="downloadImportedScannedPdf(element)">
                <mat-icon>draw</mat-icon>
                Descargar escaneado
              </button>
            } @else {
              <span class="empty-pdf-label">Sin PDF escaneado</span>
            }
          </div>
          @if (!element.can_view_detail) {
            <span class="detail-note">Detalle disponible al completar</span>
          }
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
